import axiosIns from '@/libs/axios'
import utilsService from './utilsService'

const controller = 'SemanaEpidemiologica'

export default {
  async getAll(filter) {
    const cleanFilter = utilsService.cleanObject(filter)
    return axiosIns
      .get(`${controller}?${utilsService.getQueryParams(cleanFilter)}`)
      .then(res => res.data)
  },
  async getById(id) {
    return axiosIns.get(`${controller}/${id}`).then(res => res.data)
  },
  async update(obj) {
    const cleanObj = utilsService.cleanObject(obj)
    return axiosIns.put(controller, cleanObj).then(res => res.data)
  },
  async create(obj) {
    const cleanObj = utilsService.cleanObject(obj)
    return axiosIns.post(controller, cleanObj).then(res => res.data)
  },
  async delete(id) {
    return axiosIns.delete(`${controller}/${id}`).then(res => res.data)
  },
}
